import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <div className={styles.footerCol}>
          <h4>Follow Me</h4>
          <div className={styles.socialIcons}>
            <a
              href="https://www.facebook.com/mackie.garcia.908/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://www.youtube.com/@makpack17"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>

        <div className={styles.footerCol}>
          <h4>Contact</h4>
          <p>
            <a href="tel:+16393177427">
              <i className="fas fa-phone"></i> +1 639 317 7427
            </a>
          </p>
          <p>
            <a href="mailto:buildwithmaki@gmail.com">
              <i className="fas fa-envelope"></i> buildwithmaki@gmail.com
            </a>
          </p>
        </div>

        <div className={styles.footerCol}>
          <h4>Quick Links</h4>
          <div className={styles.footerLinksGrid}>
            <ul>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/portfolio">Projects</Link>
              </li>
            </ul>
            <ul>
              <li>
                <Link to="/about">About</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
